export const postMessageToParentWindow = (message: object | string, target: string) => {
  if (!window.opener) return
  window.opener.postMessage(JSON.stringify(message), target)
}
